import { useTranslate } from "ra-core";

/**
 * Phone home. There is no greeting header: the launch splash already says
 * "Hi, {name}" on a cold open, so the first card sits right under the
 * floating top row (layout/MobileTopBar) and the useful content gets the
 * reclaimed space. The heading stays for screen readers only.
 */
export const MobileHomeFrame = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-6 pt-1">
      <h1 className="sr-only">{translate("crm.mobile.nav_home")}</h1>
      {children}
    </div>
  );
};
